
import { motion } from 'framer-motion';
import { FaClock, FaLocationDot, FaPhone } from 'react-icons/fa6';
import { IoMail, IoPersonSharp } from 'react-icons/io5';
import { PropTypes } from 'prop-types';
const ContactUs = ({socialIcons,title,contacts}) => {
    return (
        <div className="flex flex-col gap-5 mb-8">
            <h1 className="text-slate-900 text-4xl font-bold ">{title}</h1>
            <ul className='flex gap-4 list-none items-center justify-center w-full lg:justify-start'>
                {
                    socialIcons?.map((socialIcon, index) => (
                        <motion.li
                            initial={{ opacity: 0.8, scale: 1 }}
                            whileHover={{

                                opacity: 1,
                                scale: 1.01

                            }}
                            transition={{
                                type: 'spring',
                                stiffness: 300,
                                damping: 20

                            }}
                            key={index} className='group cursor-pointer '>
                            <a href={socialIcon.link}  target='_blank' rel='noreferrer' className='flex items-center justify-center w-7 h-7 2xl:w-10 2xl:h-10 rounded-full bg-blue-200 bg-opacity-65 text-blue-800'>{socialIcon.icon}</a>
                        </motion.li>
                    ))
                }
            </ul>
            {
                contacts
            }
            {/* <div className="grid grid-cols-1 md:grid-cols-[65%_30%] gap-10">
                <div className="flex flex-col  gap-5">
                    <h2 className="w-auto  text-slate-900 text-2xl font-bold leading-loose">An emergency is a situation that poses an immediate risk to health, life, property, or<br />environment. In case of emergency, please call:</h2>
                    <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
                        <div className="flex flex-col gap-5">
                            <span className="text-base font-semibold leading-normal flex   items-center ">
                                <div className="w-8">
                                    <FaLocationDot size={20} />
                                </div>
                                {contacts[0].location}</span>
                            <span className="text-base font-semibold underline leading-normal flex   items-center ">
                                <div className="w-8">
                                    <IoPersonSharp size={20} />
                                </div>
                                {contacts[0].info[0].name}</span>
                            <span className="text-base font-normal leading-normal flex items-center   ">
                                <div className="w-8">
                                    <FaPhone size={20} />
                                </div>
                                {contacts[0].info[0].mobile}</span>

                        </div>
                        <div className="flex flex-col gap-5">
                            <span className="text-base font-semibold  leading-normal flex   items-center ">
                                <div className="w-8">
                                    <FaLocationDot size={20} />
                                </div>
                                {contacts[1].location}</span>
                            {
                                contacts[1].info.map((c, index) => {
                                    return (
                                        <div key={index} className="flex flex-col my-2 gap-4">
                                            <span className="text-base font-semibold underline leading-normal flex   items-center ">
                                                <div className="w-8">
                                                    <IoPersonSharp size={20} />
                                                </div>
                                                {c.name}</span>
                                            <span className="text-base font-normal leading-normal flex items-center   ">
                                                <div className="w-8">
                                                    <FaPhone size={20} />
                                                </div>
                                                {c.mobile}</span>
                                        </div>
                                    )

                                })
                            }

                        </div>

                    </div>
                </div>
                <div className="flex flex-col gap-5">
                    <h2 className="w-auto text-slate-900 text-2xl font-bold leading-loose">Any enquiries regarding your health and wellness, kindly contact:</h2>

                    <div className="flex flex-col gap-5">
                        <span className="text-base font-semibold  leading-normal flex   items-center ">
                            <div className="w-8">
                                <FaLocationDot size={20} />
                            </div>
                            {contacts[2].location}</span>
                        <span className="text-base font-semibold my-4 leading-normal flex   items-center ">
                            <div className="w-8">
                                <FaClock size={20} />
                            </div>
                            Working office hours & by appointment</span>
                        <span className="text-base font-semibold underline leading-normal flex   items-center ">
                            <div className="w-8">
                                <IoPersonSharp size={20} />
                            </div>
                            {contacts[2].info[0].name}</span>
                        <span className="text-base font-normal leading-normal flex items-center   ">
                            <div className="w-8">
                                <FaPhone size={20} />
                            </div>
                            {contacts[2].info[0].mobile}</span>
                        <span className="text-base font-normal leading-normal flex items-center   ">
                            <div className="w-8">
                                <IoMail size={20} />
                            </div>
                            {contacts[2].info[0].email}</span>

                    </div>

                </div>
            </div> */}
        </div>
    )
}
ContactUs.propTypes = {
    socialIcons: PropTypes.any,
    contacts: PropTypes.any,
    title: PropTypes.string

}
export default ContactUs